import dayjs, { Dayjs } from "dayjs";

// Defaults to last 30 days (confirmed against the live usersMainFunnelId
// query - start_date/end_date are required, spec Section 2).
export function getDefaultUsersDateRange(): [Dayjs, Dayjs] {
  const end = dayjs();
  return [end.subtract(30, "day"), end];
}

// Resolves the effective [start, end] to send/display: the user's manual
// selection if they made one, otherwise the default last-30-days window.
export function resolveUsersDateRange(
  storedRange: [Dayjs | null, Dayjs | null]
): [Dayjs, Dayjs] {
  const [storedStart, storedEnd] = storedRange;
  if (storedStart && storedEnd) {
    return [storedStart, storedEnd];
  }
  return getDefaultUsersDateRange();
}
